import FormTaxCreate from './FormTaxCreate';
import FormTaxDelete from './FormTaxDelete';
import FormTaxFilter from './FormTaxFilter';
import FormTaxUpdate from './FormTaxUpdate';

export default Object.assign(
  {},
  {
    Create: FormTaxCreate,
    Update: FormTaxUpdate,
    Filter: FormTaxFilter,
    Delete: FormTaxDelete,
  },
);
